var scrollIndex;
function getColorList() {
  // 获取页面所有产品卡片下的handle, 并把他们拼成数组
  var colorItems = document.querySelectorAll('.common-color-item');
  var productHandles = [];
  colorItems.forEach(function(colorItem) {
    var productHandle = colorItem.getAttribute('data-product-handle');
    if (productHandle) {
      productHandles.push(productHandle);
    }
  });

  var getColorSwatchList = `${heychic_api}/web/product/getColorSwatchList`;

  var productInfoOptions = {
    method: "POST",
    headers: {
    "Content-Type": "application/json",
    "Authorization": authorization,
    "X-Shop-Id": shopIdAuth
    },
    body: JSON.stringify(productHandles)
  };

  // 获取产品颜色的接口
  fetch(getColorSwatchList, productInfoOptions)
  .then((response) => response.text())
  .then((result) => {
    let data = JSON.parse(result)
    if(data.code == 200) {
      let colorArr = data.data
      colorArr.map(v => {
        productHandles.map((item, index) => {
          if(v.product_handle == item && Object.keys(v.swatch_arr).length) {
            // console.log('====', item, index, v)
            let newIndex = index + 1
            let colorDom = document.getElementById('color-' + newIndex + '-' + v.product_number);

            let colorList = v.swatch_arr
            let newColorList = []
            for (const i in colorList) {  
              newColorList.push({
                handle: i,
                image: colorList[i],
              })
            }

            // console.log('====newColorList', newColorList)
            let colorIndex = newColorList.findIndex(item => item.handle === v.product_handle);
            let firstColor = newColorList[colorIndex]
            newColorList.splice(colorIndex, 1)
            newColorList.unshift(firstColor)

            let colorlistHTML = newColorList.map((product, i) => {
              // 按需加载色块图片
              let colorLength;
              if(window.innerWidth > 750) {
                colorLength = 6
              } else {
                colorLength = 3
              }

              if(i <= colorLength - 1){
                return product.image[0] == '#' ?
                  `
                    <div onclick="getProductDetail('${product.handle}', ${newIndex}, ${v.product_number}, ${i})" 
                      class="color-item ${v.product_handle == product.handle ? 'active-item' : 'choose-item'}">
                      <div class="div-color-type" style="background:${product.image}"></div>
                    </div>
                  `
                  :
                  `
                    <div onclick="getProductDetail('${product.handle}', ${newIndex}, ${v.product_number}, ${i})"
                      class="color-item ${v.product_handle == product.handle ? 'active-item' : 'choose-item'}">
                      <img src="${product.image}" alt="${product.handle}">
                    </div>
                  `
                }
              }).join('');

            let jumpUrl = location.pathname.indexOf('/collections/') >= 0 
              ? `${location.pathname}/products/${v.product_handle}`
              : `/products/${v.product_handle}`

            let openDiv = `<a href="${jumpUrl}" class="show-more-color"><img src="https://cdn.heychic.net/material/model/colorDots-1218ea820bf0383.png" class="colorDots" alt="colorDots" /></a>`
            // let openDiv = `<div class="show-more-color" onclick="showMoreColor(event)">+</div>
            // <div class="close-color"><img onclick="closeColor(event)" src="{{ 'close-color.png' | asset_url}}" alt="close color"/></div>`
            colorlistHTML += openDiv

            if(colorDom && Object.keys(v.swatch_arr).length > 1){
              colorDom.innerHTML = colorlistHTML;
            
              // 向下取整 计算出一行最多能展示几个
              let yhzs;
              if(window.innerWidth > 750){
                yhzs = 7;
              }else{
                // yhzs = Math.floor(colorDom.clientWidth / 32)
                yhzs = 4;//显示三个色块
              }
              let lineNum = 1 // 选择最多展示几行
              if(newColorList.length >= yhzs * lineNum) {
                colorDom.classList.add('many-color')
                let addNum = newColorList.length - (yhzs * lineNum - 1)
                // colorDom.querySelector('.show-more-color').textContent = "+" + addNum
                colorDom.querySelector('.show-more-color').innerHTML = `<img src="https://cdn.heychic.net/material/model/colorDots-1218ea820bf0383.png" class="colorDots" alt="colorDots" />`

                let allColorDom = colorDom.querySelectorAll('.color-item')
                allColorDom.forEach(function(colorItem, index) {
                  if(index < yhzs * lineNum - 1) {
                    colorItem.style.display = 'block'
                  }
                });
              }
            }

            // 针对排序后的商品轮播
            // var swiperSort = new Swiper(`.mySwiper-sort-${newIndex}`, {
            //   lazy: {
            //     loadPrevNext: false,  // 不加载前后图片
            //     loadOnTransitionStart: false, // 在切换开始时不加载
            //   },
            //   loop: true,
            //   effect: 'slide',
            //   pagination: {
            //     el: '.swiper-pagination',
            //   },
            //   navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            //   },
            //   on: {
            //     lazyImageLoad: function (swiper, slide, image) {
            //       slide.querySelector('.swiper-lazy-preloader').style.display = 'block';
            //     },
            //     lazyImageReady: function (swiper, slide, image) {
            //       slide.querySelector('.swiper-lazy-preloader').style.display = 'none';
            //     },
            //   }
            // });

            // if(colorDom.scrollWidth > colorDom.clientWidth) {
                // colorDom.classList.add('many-color')
                // let addNum = newColorList.length - 9
                // colorDom.querySelector('.show-more-color').textContent = "+" + addNum
            // }
          }
          return
        })
        return
      })
    }
  })
  .catch((error) => console.error(error))

  var detailHeaders = new Headers();
  detailHeaders.append("Content-Type", "application/json");

  var detailOptions = {
    method: "POST",
    headers: detailHeaders,
    body: JSON.stringify(productHandles),
    redirect: "follow"
  };

  // 获取产品心愿数的接口(先隐藏)
  // fetch(`${heychic_api}/web/Product/getCollectWishList`, detailOptions)
  // .then((response) => response.text())
  // .then((result) => {
  //   let data = JSON.parse(result)
  //   if(data.code == 200) {
  //     let productArr = data.data
  //     productArr.map(v => {
  //       productHandles.map((item, index) => {
  //         if(v.product_handle == item) {
  //           let newIndex = index + 1
  //           let productDom = document.getElementById('product-' + newIndex + '-' + v.product_number);
  //           if(productDom){
  //             // productDom.querySelector('.common-product-wish-num').textContent = v.num
  //             var wishNumLists = productDom.querySelectorAll('.card-wishlist');
  //             var wishNumAdded = JSON.parse(localStorage.getItem('wishlistItem'));
  //             // 首先检查 wishNumAdded 是否包含 v.product_handle
  //             const shouldHighlight = wishNumAdded && wishNumAdded.includes(v.product_handle);

  //             wishNumLists.forEach(wishNum => {
  //               wishNum.querySelector('.common-product-wish-num').textContent = v.num || 0; // 设置收藏数量

  //               if (shouldHighlight) {
  //                 wishNum.querySelector('.common-product-wish-num').style.color = '#272727'; // 改变颜色
  //                 wishNum.querySelector('.wishlist-icon').classList.add('wishlist-added')//高亮收藏样式
  //               }else{
  //                 wishNum.querySelector('.wishlist-icon').classList.remove('wishlist-added')
  //               }
  //             });
  //           }
  //         }
  //         return
  //       })
  //       return
  //     })
  //   }
  // })
  // .catch((error) => console.error(error))

  // 获取产品预售信息
  var productInfo = `${heychic_api}/web/product/productInfo`;
  let params = {
    shop_id: shopIdAuth,
    product_handle: productHandles,
  }

  var productInfoOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": authorization,
      "X-Shop-Id": shopIdAuth
    },
    body: JSON.stringify(params)
  };

  fetch(productInfo, productInfoOptions)
  .then((response) => response.text())
  .then((result) => {
    let data = JSON.parse(result)
    if(data.code == 200) {
      let productData = data.data

      // 收集页面上所有类名为 product-item 且含有 data-product-id 的 DOM 元素
      const productItems = Array.from(document.querySelectorAll('.product-item[data-product-id]'));

      // 循环遍历接口返回的数据
      productData.forEach(product => {
        // 获取 product_number
        const productNumber = product.product_number;

        // 找到对应的 DOM 元素
        const matchingItem = productItems.find(item => {
          return item.getAttribute('data-product-id') == productNumber;
        });

        // 如果找到匹配的 DOM 元素，并且 all_variant_is_presale 为 1
        if (matchingItem && product.all_variant_is_presale === 1) {
          // 将类名为 hidden-pre-flag 的 DOM 元素的样式改为 display: block
          const hiddenPreFlag = matchingItem.querySelector('.hidden-pre-flag');
          if (hiddenPreFlag) {
            hiddenPreFlag.style.display = 'block';
          }
        }

          // 循环遍历 variant_list
        product.variant_list.forEach(variant => {
          const variantId = variant.variant_id;

          // 找到所有具有相同 data-pre-variant-id 的 DOM 元素
          const variantElements = matchingItem ? matchingItem.querySelectorAll(`[data-pre-variant-id="${variantId}"]`) : [];

          // 处理相关 DOM 元素
          variantElements.forEach(el => {
            const greyPreorderTip = el.querySelector('.grey-preorder-tip');
            const redPreorderTips = el.querySelectorAll('.red-preorder-tip'); // 可能存在多个
            const preTimeSpan = el.querySelector('.pre-time');
            const preStr = variant.presale_data ? variant.presale_data.show_time_str : '';

            if (variant.is_presale === 1) {
              // 如果 is_presale 为 1，隐藏 grey-preorder-tip，显示所有 red-preorder-tip
              if (greyPreorderTip) {
                greyPreorderTip.style.display = 'none';
              }
              redPreorderTips.forEach(tip => {
                tip.style.display = 'block';
              });
            } else {
              // 如果 is_presale 为 0，显示 grey-preorder-tip，隐藏所有 red-preorder-tip
              if (greyPreorderTip) {
                greyPreorderTip.style.display = 'block';
              }
              redPreorderTips.forEach(tip => {
                tip.style.display = 'none';
              });
            }

            // 更新 pre-time 的内容
            if (preTimeSpan) {
              preTimeSpan.textContent = preStr;
            }
          });
        });
      });
    } else if (data.code == 400) {
      showToastTips(data.message, 'error');
    }
  })
  .catch((error) => {
    console.log(error)
  });
}

getColorList()

function shouldShowCommonSaleText(product) {
  const rawTags = product && product.tags;
  const tags = Array.isArray(rawTags)
    ? rawTags
    : String(rawTags || '').split(',').map(function(tag) { return tag.trim(); }).filter(Boolean);
  return !tags.includes('hide-save-more');
}

// 获取产品详情接口
function getProductDetail(name, newIndex, oldId, colorIndex) {
  document.getElementById('product-' + newIndex + '-' + oldId).classList.add('has-halo-block-loader')
  fetch(`/products/${name}.js`)
    .then((response) => response.json())
    .then((newResult) => {
      const showSaleText = shouldShowCommonSaleText(newResult);



      // 获取要复制和替换的原始 DOM 元素
      let productDom = document.getElementById('product-' + newIndex + '-' + oldId);
      productDom.classList.remove('has-halo-block-loader')

      // 复制整个 DOM 结构，包括所有子节点
      var clonedElement = productDom.cloneNode(true);

      // 替换标题！
      var cardTitles = clonedElement.querySelectorAll('.card-title');
      cardTitles.forEach(function(cardTitle) {
        var textElements = cardTitle.querySelectorAll('.text');
        textElements.forEach(function(textElement) {
          textElement.textContent = newResult.title;
        });
      });

      // 替换图片
      let newImagesList210x = addSizeBeforeExtension(newResult.images, '210x')
      let newImagesList370x = addSizeBeforeExtension(newResult.images, '370x')
      let newImagesList530x = addSizeBeforeExtension(newResult.images, '530x')
      // 系列页处理-轮播相关
      if(document.body.classList.contains('template-collection') || document.body.classList.contains('template-index')){
        // console.log('系列页处理-轮播相关是pc')
      // if(document.body.classList.contains('template-collection')){
        var swiperElements = clonedElement.querySelector('.swiper-wrapper');
        var pcImgDoms = clonedElement.querySelector('.card-media-pc');
        if(swiperElements){
        swiperElements.style.transform = 'translate3d(0px, 0px, 0px)'
        }
        const swiperHTML = newResult.images.map((image, index) => {
          if(index < 3){//只显示三张图片
            return `
              <img class="swiper-slide ${index == 0 ? 'swiper-slide-active' : ''} ${index == 1 ? 'swiper-slide-next' : ''}" 
                srcset="${newImagesList210x[index]} 210w, ${newImagesList370x[index]} 370w, ${newImagesList530x[index]} 530w" 
                src="${image}"
                alt="${newResult.title}"
                width="1366" 
                height="2048" 
                sizes="(min-width: 1100px) 1366px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
                loading="lazy"
                role="group" aria-label="${index + 1} / ${newResult.images.length}"
                data-swiper-slide-index="${index}">
            `;
          }
        }).join('');

      //   const swiperHTML = newResult.media.slice(0, 3).map((media, index) => {
      //   const baseClass = `swiper-slide ${index === 0 ? 'swiper-slide-active' : ''} ${index === 1 ? 'swiper-slide-next' : ''}`;
      //   const aria = `role="group" aria-label="${index + 1} / ${newResult.media.length}" data-swiper-slide-index="${index}"`;

      //   if (!media.sources) {
      //     return `
      //       <img class="${baseClass}" 
      //         srcset="${newImagesList210x[index]} 210w, ${newImagesList370x[index]} 370w, ${newImagesList530x[index]} 530w" 
      //         src="${media.src}" 
      //         alt="${newResult.title}" 
      //         width="1366" height="2048" 
      //         sizes="(min-width: 1100px) 1366px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" 
      //         loading="lazy" ${aria}>
      //     `;
      //   } else {
      //     return `
      //       <div class="${baseClass}" ${aria}>
      //         <video 
      //           src="${media.sources[0].url}" 
      //           poster="${media.preview_image.src}" 
      //           muted
      //           playsinline
      //           autoplay
      //           loop
      //           preload="none"
      //           style="width: 100%; height: 100%; object-fit: cover;">
      //         </video>
      //       </div>
      //     `;
      //   }
      // }).join('');


        if(window.innerWidth > 768){
          pcImgDoms.innerHTML = swiperHTML;
        }else{
          swiperElements.innerHTML = swiperHTML;
        }
      } else { // 其他页面
        var cardMediaElements = clonedElement.querySelectorAll('.card-media');
        cardMediaElements.forEach(function(cardMediaElement) {
          var imgElements = cardMediaElement.querySelectorAll('img');
          if (imgElements.length >= 2) {
            // 第一个 <img> 标签的 src 替换为 'xxx'
            imgElements[0].src = newResult.images[0]
            imgElements[0].srcset = `${newImagesList210x[0]} 210w, ${newImagesList370x[0]} 370w, ${newImagesList530x[0]} 530w`;
            
            // 第二个 <img> 标签的 src 替换为 'xxx2'
            imgElements[1].src = newResult.images[1]
            imgElements[1].srcset = `${newImagesList210x[1]} 210w, ${newImagesList370x[1]} 370w, ${newImagesList530x[1]} 530w`;
          }
        });
      }

      var addSwiper = clonedElement.querySelector('.add-swiper-slide');
      const addSwiperHTML = newResult.images.map((image, index) => {
        return `
          <img class="modalImg" 
            srcset="${newImagesList210x[index]} 210w, ${newImagesList370x[index]} 370w, ${newImagesList530x[index]} 530w" 
            src="${image}"
            alt="${newResult.title}"
            width="1366" 
            height="2048" 
            sizes="(min-width: 1100px) 1366px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
            loading="lazy"
            role="group" aria-label="${index + 1} / ${newResult.images.length}">
        `;
      }).join('');

      if(addSwiper){
        addSwiper.innerHTML = addSwiperHTML;//快速加入购物车弹出的图片
      }

        
        
      // 价格部分
      let priceDoms = clonedElement.querySelectorAll('.product-price-box');
      // 判断是否有优惠价格
      if (newResult.compare_at_price > newResult.price) {
        priceDoms.forEach(dom => dom.classList.add('price--on-sale'));
      } else {
        priceDoms.forEach(dom => dom.classList.remove('price--on-sale'));
      }

      // 处理原价
      var regularDom = clonedElement.querySelectorAll('.card-information .price-item--regular');
      regularDom.forEach(function(item, index) {
        if(index == 0) {
          var money = item.innerText
          var number = money.match(/[\d,]+(\.\d+)?/)[0];
          var newPrice = newResult.compare_at_price > newResult.price ? 
               formatPrice(newResult.compare_at_price) : 
              formatPrice(newResult.price)
          var newData = money.replace(number, newPrice);
          // if(newResult.tags.includes('Not For Sale')){
          //   item.classList.add('price-item-regular-through');
          // }
          item.textContent = newData;
          regularDom[1].innerText = newData
        }
      });
      // 处理现价
      let saleDom = clonedElement.querySelector('.card-information .price-item--sale');
      var saleMoney = saleDom.innerText;
      var saleNumber = saleMoney.match(/[\d,]+(\.\d+)?/)[0];
      saleDom.textContent = saleMoney.replace(saleNumber, (newResult.price / 100).toFixed(2));


      // 处理色块切换后的优惠价格(仅针对于有活动时)
      // let nowDomPrice = clonedElement.querySelector('.card-information .product-common-sale-box .discount-price');
      // if(newResult.tags.includes('Not For Sale')){
      //   nowDomPrice.textContent = saleMoney.replace(saleNumber, (newResult.price * 0.8 / 100).toFixed(2));
      // }


      // 快速加入购物车价格相关
      // 处理原价
      // var regularDoms = clonedElement.querySelectorAll('.popup-content .price-item--regular');
      var regularDoms = clonedElement.querySelectorAll('.product-price-box .price-item--regular');
      regularDoms.forEach(function(item, index) {
        if(index == 0) {
          var money = item.innerText
          var number = money.match(/[\d,]+(\.\d+)?/)[0];
          var newPrice = newResult.compare_at_price > newResult.price ? 
            formatPrice(newResult.compare_at_price) : 
            formatPrice(newResult.price)
          var newData = money.replace(number, newPrice);
          item.textContent = newData;
          regularDoms[1].innerText = newData
        }
      });
      // 处理现价
      // let saleDoms = clonedElement.querySelector('.popup-content .price-item--sale');
      let saleDoms = clonedElement.querySelector('.product-price-box .price-item--sale');
      var saleMoney = saleDoms.innerText
      var saleNumber = saleMoney.match(/[\d,]+(\.\d+)?/)[0];
      saleDoms.textContent = saleMoney.replace(saleNumber, (newResult.price / 100).toFixed(2));


      // 处理活动标签。色块切换会克隆上一张卡片，没文案的商品必须把 class 和文字清掉
      clonedElement.querySelectorAll('.product-common-sale-box').forEach(function(saleBox) {
        saleBox.querySelectorAll('.product-sale-item.hidden-tips').forEach(function(item) {
          item.classList.toggle('show-save-more', showSaleText);
        });
        saleBox.querySelectorAll('.product-sale-item.sale-activity-text').forEach(function(item) {
          if (!showSaleText) item.textContent = '';
        });
      });

      // 处理颜色高亮
      let colorDom = clonedElement.querySelectorAll('.color-item');
      colorDom.forEach(function(colorItem, index) {
        colorItem.classList.remove('active-item')
        if(index == colorIndex) {
          colorItem.classList.add('active-item')
        }
      });

      // 处理跳转
      var aTags = clonedElement.querySelectorAll('a');
      aTags.forEach(function(aTag) {
        aTag.href = location.pathname.indexOf('/collections/') >= 0 
          ? location.pathname + '/products/' + newResult.handle
          : '/products/' + newResult.handle
      });

      // 判断是否喜欢
      let wishDom = clonedElement.querySelectorAll('.wishlist-icon')
      var wishList = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
      var wishNumLists = clonedElement.querySelectorAll('.common-product-wish-num');//获取收藏数量

      // 快速加购弹出,wishlist-icon是一个集合
      wishDom.forEach(function(item) {
        item.setAttribute('data-wishlist-handle', newResult.handle)
        item.setAttribute('data-product-id', newResult.id)

        if(wishList.includes(newResult.handle)) {
          item.classList.add('wishlist-added')
        } else {
          item.classList.remove('wishlist-added')
        }
      });
        

      // 处理收藏数量
      const shouldHighlightChange = wishList && wishList.includes(newResult.handle);

      wishNumLists.forEach(wishNum => {
        if (shouldHighlightChange) {
          wishNum.style.color = '#272727'; // 改变颜色
        }else{
          wishNum.style.color = '#6f6f6f'; // 改变颜色
        }
      });

      // 获取喜欢的人数
      var formdata = new FormData();
      formdata.append("product_handle", newResult.handle);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        headers: {
          "X-Shop-Id": shopIdAuth,
        },
      };

      fetch(`${heychic_api}/web/Product/getColorSwatch`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result)
        if(data.code == 200) {
          // document.getElementById('product-wish-num').textContent = data.data.wish_num || 0
          var wishNumList = clonedElement.querySelectorAll('.common-product-wish-num');
          wishNumList.forEach(function(wishNum) {
            // console.log(wishNum,'wishNum---')
            wishNum.textContent = data.data.wish_num || 0
          });
        }
      })
      .catch((error) => console.error(error));

      // 切换色块新增属性，实时获取产品id
      clonedElement.setAttribute('data-new-id',newResult.id);
      // 将替换后的复制的 DOM 结构替换原始的 DOM 结构
      productDom.parentNode.replaceChild(clonedElement, productDom);

      // 规格部分(有sku情况下)
      // let sizeDom = document.getElementById('select-' + newIndex + '-' + oldId);
      // let optionIndex = sizeDom?.getAttribute("data-option-index")
      // let optionIndex0 = sizeDom?.getAttribute("data-option-index0")
      // let sectionList = sizeDom?.getAttribute("data-color-sectionList")
      // const colorlistHTML = newResult?.variants.map((variant, index) => {
      //   return `
      //     <div class="swatch-element ${variant.available ? 'available' : 'soldout'}" data-value="${variant.title}">
      //         <input class="single-option" type="radio" 
      //           name="SingleOptionSelector-${optionIndex0}-${newResult.id}-${sectionList}" 
      //           data-index="option${optionIndex}" 
      //           value="${variant.title}" 
      //           id="SingleOptionSelector${optionIndex0}-${variant.title}-${newResult.id}-${sectionList}">
      //         <label class="single-label " title="${variant.title}" for="SingleOptionSelector${optionIndex0}-${variant.title}-${newResult.id}-${sectionList}" id="${oldId}-${variant.id}">  
              
      //         <div onclick="selectCart(${variant.id},${optionIndex0},${oldId},${newIndex},event)" class="${variant.available ? 'textCenter' : 'soldFlex'} sidebar-mobile">
      //           <span class="name">${variant.title}</span>
      //           <span class="text ${variant.available ? 'available' : 'showTextPc'}">Sold out</span>
      //         </div>

      //         <a class='sidebar-pc-hover' onclick="addCartPc(${variant.id},${optionIndex0})" href="javascript:void(0)" data-cart-sidebar>
      //         <div class="${variant.available ? 'textCenter' : 'soldFlex'} sidebar-pc">
      //           <span class="name">${variant.title}</span>
      //           <span class="text ${variant.available ? 'available' : 'showTextPc'}">Sold out</span>
      //         </div>   
      //         </a> 
      //         </label>
      //     </div>
      //   `
      // }).join('');


      // 获取加购按钮
      const changeBuyICon = clonedElement.querySelector('.card-grid__hidden .variants');
      if(changeBuyICon) { 
        changeBuyICon.innerHTML = ``;
      }
      

      // 获取对应的产品dom
      const getDomId =  `#product-${newIndex}-${oldId}`
      // sku弹框
      $('.variants-popup-bot-change').empty();
      const variantsList = newResult.variants;
      
      // 有sku情况下,底部弹框(新版)
      if(variantsList.length > 0){
        variantsList.forEach((item) => {
          $(`${getDomId} .variants-popup-bot-change`).append(`<div class="variants-popup-bot-name ${!item.available ? 'variant-name-sold-out':''}" data-cart-sidebar onclick="addToCartH5New('${item.id}')">${convertAuToUsSize(item.title,2)}</div>`)
        });

        const haveSizeHTML = `
        <a class="button button-ATC hideIconBtn" data-quickshop-popup="" role="button" style="visibility: visible;" href="/collections/new-in/products/lari-blue-abstract-halter-neck-mini-dress">
            <div class="showPcAdd" onclick="showSkuMask(event,'${oldId}',${newIndex},'${name}')">Add To Bag<span class="add-icon">+</span></div>
            <img src="https://cdn.heychic.net/material/model/addBagnew-4d3ca2e23505429.png" alt="shopCardIcon" class="showMbIcon" onclick="showSkuMask(event,'${oldId}',${newIndex},'${name}')">
        </a>`
        if(changeBuyICon){
          changeBuyICon.innerHTML = haveSizeHTML;
        }
        

        // 主要用于pc离开后,置空弹框内容,防止错乱
        const popupSkuListColor = document.querySelectorAll('.variants-popup-bot-change');
        popupSkuListColor.forEach(item => { 
          item.addEventListener('mouseleave', () => { 
            item.innerHTML = '';
            item.style.display = 'none';
          });
        });
      }else{
        // 规格无sku情况下
        let noSizeDom = document.querySelector(`[data-new-id='${newResult.id}']`);
        const getNoSizeHTML = noSizeDom.querySelector('.variants');
        const addBagIcon = "{{ 'addBag-new.png' | asset_url }}"; // 先让 Liquid 渲染出来
        const noSizeHTML = `
          <div>
            <input type="hidden" name="id" value="${newResult.variants[0].id}">
            <input type="hidden" name="quantity" value="1">
            <button onclick="getNoSku(${newResult.variants[0].id})" class="sidebar-pc button button-ATC hideIconBtn" type="submit"  data-cart-sidebar="" data-btn-addtocart="" style="visibility: visible;">
              <div class="showPcAdd">Add to bag<span class="add-icon">+</span></div>
              <img src="https://cdn.heychic.net/material/model/addBagnew-4d3ca2e23505429.png" alt="shopCardIcon" class="showMbIcon" id="showMbIconId">
            </button>
            <button class="sidebar-mobile button button-ATC hideIconBtn" type="submit"  data-cart-sidebar="" onclick="getNoSku(${newResult.variants[0].id})" style="visibility: visible;">
              <div class="showPcAdd">Add to bag<span class="add-icon">+</span></div>
              <img src="https://cdn.heychic.net/material/model/addBagnew-4d3ca2e23505429.png" alt="shopCardIcon" class="showMbIcon" id="showMbIconId">
            </button>
          </div>
        `
        getNoSizeHTML.innerHTML = noSizeHTML;
      }

      // 角标dom
      const productBadges = clonedElement.querySelector('.halo-productBadges--right');

      // 处理预售 preordr
      let preDom = clonedElement.querySelector('[data-pre-product-id]')
      if(preDom){
        preDom.setAttribute('data-pre-product-id', newResult.id);
        // 获取新产品预售信息
        var newProductInfo = `${heychic_api}/web/product/productInfo`;
        let newParams = {
          shop_id: shopIdAuth,
          product_number: newResult.id,
        }

        var newProductInfoOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": authorization,
            "X-Shop-Id": shopIdAuth
          },
          body: JSON.stringify(newParams)
        };

        fetch(newProductInfo, newProductInfoOptions)
        .then((response) => response.text())
        .then((result) => {
          let data = JSON.parse(result)
          if(data.code == 200) {
            let preOrderData = data.data
            // console.log(preOrderData, '====preOrderData===')
            const preOrderHtml = preOrderData[0].variant_list.map((variant, index) => {
              var tipsHtml = variant.presale_data && variant.presale_data.show_time_str ? 
              `<div class="preorder-tip red-preorder-tip">Pre-order item. Estimate to ship: <span class="pre-time">${variant.presale_data.show_time_str}</span></div>
              <div class="preorder-tip red-preorder-tip preorder-tip-new">For orders outside of Australia, place separate orders to receive in-stock items first.</div>`
              :
              `<div class="preorder-tip grey-preorder-tip">Expected To Ship Within 2 Business Days</div>`
              return `
                <div class="preorder-box" data-pre-variant-id="${variant.variant_id }">
                  ${tipsHtml}
                </div>
              `
            }).join('');
            preDom.innerHTML = preOrderHtml;

            // 处理预售标签
            const preBadge = productBadges.querySelector('.preorder-badge');
            // 如果所有sku都是预售 给左上角打个标
            if (preOrderData[0].all_variant_is_presale === 1) {
              if(!preBadge){
                const span = document.createElement('span');
                span.className = 'badge preorder-badge';
                span.setAttribute('aria-hidden', 'true');
                span.textContent = 'pre order';
                productBadges.appendChild(span);
              }
            } else {
              if (preBadge) {
                preBadge.remove();
              }
            }
          } else if (data.code == 400) {
            showToastTips(data.message, 'error');
          }
        })
        .catch((error) => {
          console.log(error)
        });
        preDom.innerHTML = `
          <div class="preorder-box" data-pre-variant-id="43431549337657" style="display: none;">
            <div class="preorder-tip red-preorder-tip" style="display: none;">Pre-order item. Estimate to ship: <span class="pre-time"></span></div>
            <div class="preorder-tip red-preorder-tip preorder-tip-new" style="display: none;">For orders outside of Australia, place separate orders to receive in-stock items first.</div>
            <div class="preorder-tip grey-preorder-tip" style="display: block;">Expected To Ship Within 2 Business Days</div>
          </div>`
      }

      // 处理折扣标签sale
      let saleBadge = productBadges.querySelector('.sale-badge');

      if (newResult.compare_at_price > newResult.price) {
        if (!saleBadge) {
          saleBadge = document.createElement('span');
          saleBadge.className = 'badge sale-badge';
          saleBadge.setAttribute('aria-hidden', 'true');
          productBadges.appendChild(saleBadge);
        }

        if (newResult.tags.includes('W/H Clearance')) {
          saleBadge.textContent = 'W/H Clearance';
        } else if (newResult.tags.includes('Final Sale')) {
          saleBadge.textContent = 'Final Sale';
        } else {
          saleBadge.textContent = 'Sale';
        }
      } else {
        if (saleBadge) {
          saleBadge.remove();
        }
      }


      // 处理豪华标签
      const existingBadge = productBadges.querySelector('.luxe-badge');
      if (newResult.tags.includes('Heychic Luxe')) {
        if (!existingBadge) {
          const span = document.createElement('span');
          span.className = 'badge luxe-badge';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = 'HEYCHIC LUXE';
          productBadges.appendChild(span);
        }
      } else {
        if (existingBadge) {
          existingBadge.remove();
        }
      }

      // 处理缺货标签
      const soldOutBadge = productBadges.querySelector('.sold-out-badge');
      if (!newResult.available) {
        if (!soldOutBadge) {
          const span = document.createElement('span');
          span.className = 'badge sold-out-badge';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = 'Sold out';
          productBadges.appendChild(span);
        }
      } else {
        if (soldOutBadge) {
          soldOutBadge.remove();
        }
      }

      var swiper = new Swiper(`.mySwiper-${newIndex}-${oldId}`, {
          lazy: {
            loadPrevNext: false,  // 不加载前后图片
            loadOnTransitionStart: false, // 在切换开始时不加载
          },
          effect: 'slide',
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            lazyImageLoad: function (swiper, slide, image) {
              slide.querySelector('.swiper-lazy-preloader').style.display = 'block';
            },
            lazyImageReady: function (swiper, slide, image) {
              slide.querySelector('.swiper-lazy-preloader').style.display = 'none';
            },
          }
      });
    })
    .catch(error => {
      let productDom = document.getElementById('product-' + newIndex + '-' + oldId);
      productDom.classList.remove('has-halo-block-loader')
      console.log(error, '=====error=====');
  });
}

function showMoreColor(event) {
  event.srcElement.parentNode.classList.add('open-color-list')
  event.srcElement.parentNode.classList.remove('many-color')
}

function closeColor(event) {
  event.srcElement.parentNode.parentNode.classList.add('many-color')
  event.srcElement.parentNode.parentNode.classList.remove('open-color-list')
}

function addSizeBeforeExtension(urls, size) { 
  // 使用正则表达式匹配 '.jpg' 前的部分并进行替换 
  return urls.length && urls.map(url => url.replace(/(\.jpg)/, `_${size}$1`)); 
}

function getCurrencySymbol(currencyCode) {
  const currencySymbols = {
    "USD": "$",
    "EUR": "€",
    "JPY": "¥",
    "GBP": "£",
    "AUD": "$",
    "CAD": "$",
    "CHF": "Fr",
    "CNY": "¥",
    "SEK": "kr",
    "NZD": "$",
    "KRW": "₩",
    "SGD": "$",
    "NOK": "kr",
    "MXN": "$",
    "INR": "₹",
    "RUB": "₽",
    "ZAR": "R",
    "BRL": "R$",
    "TRY": "₺",
    "HKD": "HK$",
    "IDR": "Rp",
    "ISK": "kr",
    "PHP": "₱",
    "DKK": "kr",
    "PLN": "zł",
    "HUF": "Ft",
    "CZK": "Kč",
    "THB": "฿",
    "MYR": "RM",
    "HRK": "kn",
    "RON": "lei",
    "ILS": "₪",
    "CLP": "$",
    "AED": "د.إ",
    "COP": "$",
    "SAR": "﷼",
    "BGN": "лв",
    "PKR": "₨",
    "EGP": "£",
    "DZD": "د.ج",
    "KWD": "د.ك",
    "QAR": "﷼",
    "KES": "KSh",
    "VND": "₫",
    "ARS": "$",
    "TWD": "NT$",
    "BDT": "৳",
    "NPR": "₨",
    "IQD": "ع.د",
    "COP": "COL$",
    "LKR": "Rs",
    "UGX": "USh",
    "GHS": "GH₵",
    "RON": "RON",
    "MAD": "د.م.",
    "UZS": "so'm"
  };

  return currencySymbols[currencyCode] || "Unknown";
}